import type {ActionResponseWithText, Auth, Capture, Exemplar, Inventory, User} from 'typings/portaro.be.types';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type ModalConversationService from '../commons/conversation/modal-conversation.service';
import {Kind, SearchType} from '../commons/constants/portaro.constants';
import type FinishedResponseInteractionService from '../commons/services/finished-response-interaction.service';
import {lastValueFrom} from 'rxjs';
import type ObservableCaptureDataService from '../commons/data-services/observable-capture.data-service';
import {isInterruptedActionResponse} from '../commons/conversation/modal-utils';

export default class SearchedInventoryController {
    public static controllerName = 'SearchedInventoryCtrl';

    public user: User;
    public inventory: Inventory;

    /*@ngInject*/
    constructor(private modalConversationService: ModalConversationService,
                private CONTEXT_PATH: string,
                private currentAuth: Auth,
                private finishedResponseInteractionService: FinishedResponseInteractionService,
                private observableCaptureDataService: ObservableCaptureDataService) {
        this.user = this.currentAuth.activeUser;
    }

    public init(inventory: Inventory) {
        this.inventory = inventory;
    }

    @ngAsync()
    public async showCapturingForm() {
        const modalModel = {
            staticSearchParams: {
                kind: Kind.KIND_EXEMPLAR,
                type: SearchType.TYPE_SEARCH_SELECTION
            }
        };

        while (true) {
            try {
                const exemplar = await this.modalConversationService.searchItem<Exemplar>(modalModel);
                const result = await this.captureExemplar(exemplar);
                await this.finishedResponseInteractionService.showSuccessResponseInToastIfPossible(result);
            } catch (exceptionResponse) {
                if (isInterruptedActionResponse(exceptionResponse)) {
                    break;
                } else {
                    this.finishedResponseInteractionService.showFailedResponseInToast(exceptionResponse);
                }
            }
        }
    }

    private captureExemplar(ex: Exemplar): Promise<ActionResponseWithText> {
        const request: Capture = {
            id: null,
            inventory: this.inventory,
            identifier: ex.designation, // TODO: change to user's entered code
            exemplar: ex.id,
            quantity: ex.quantity,
            captureWay: 0
        };

        return lastValueFrom(this.observableCaptureDataService.putCapture(request));
    }
}
